import { supabase } from "@/lib/supabaseClient";

export interface ActivityEvent {
  id?: string;
  user_id?: string;
  email: string;
  event_type: "user_signup" | "test_completed" | "ee_corrected" | "flashcard_created" | "error_saved" | "premium_interest" | "plan_changed" | string;
  resource_type?: "test" | "flashcard" | "error" | "profile" | string | null;
  resource_id?: string | null;
  metadata?: any;
  created_at?: string;
}

export const activityService = {
  /**
   * Tracks a user activity event securely by inserting a log into supabase.
   * Gracefully fails with a console warning on failure so it never blocks
   * the main study or test workflow.
   */
  async trackUserActivity(
    eventType: ActivityEvent["event_type"],
    resourceType?: ActivityEvent["resource_type"],
    resourceId?: ActivityEvent["resource_id"],
    metadata?: any
  ): Promise<void> {
    if (!supabase) {
      console.warn("[ActivityService] Supabase client not configured. Activity not tracked:", eventType);
      return;
    }

    try {
      const { data: sessionData } = await supabase.auth.getSession();
      const user = sessionData?.session?.user;
      if (!user) return;

      const payload: ActivityEvent = {
        user_id: user.id,
        email: user.email?.toLowerCase().trim() || "",
        event_type: eventType,
        resource_type: resourceType || null,
        resource_id: resourceId || null,
        metadata: metadata || {},
        created_at: new Date().toISOString()
      };

      const { error } = await supabase.from("user_activity_events").insert([payload]);
      if (error) {
        console.warn(`[ActivityService] Error inserting activity ${eventType}:`, error.message);
      }
    } catch (err) {
      console.warn("[ActivityService] Unexpected failure tracking user activity:", err);
    }
  }
};
